import { forwardRef } from 'react';

import type { WithChildren } from '@dynatrace/strato-components/core';

import { visuallyHiddenCSS } from './VisuallyHidden.sty.js';

/**
 * Element with styles that visually hides the contents.
 * @internal
 */
export const VisuallyHidden = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  WithChildren
>(({ children }, forwardedRef) => (
  <div ref={forwardedRef} className={visuallyHiddenCSS}>
    {children}
  </div>
));
